export const PROXY_SERVER_PORT = 5001;
export const TEMP_URL_DELIMITER = '__PTEMP__';
